import React from "react";
import { Form, Button } from "react-bootstrap";
import "./register.css";

const Register = ({ handleModal }) => {


    return (
        <div className="signup">
            <div className="register-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="register-form">
                                <h1>Sign In</h1>
                                <p>Welcome, Please fill your detail to create your account</p>
                                <div className="rigister-tab">
                                    <Form>
                                       <Form.Group controlId="formBasicFirst">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter your email"
                                                name="phone"
                                                autoComplete="off"
                                            />
                                        </Form.Group>
                                        <Form.Group controlId="formBasicPassword">
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control
                                                type="password"
                                                placeholder="Enter your password"
                                                name="password"
                                                autoComplete="off"

                                            />
                                        </Form.Group>
                                        <Form.Group controlId="formBasicPassword">
                                            <Form.Label>Confirm Password</Form.Label>
                                            <Form.Control
                                                type="password"
                                                placeholder="Confirm password"
                                                name="password"
                                                autoComplete="off"

                                            />
                                        </Form.Group>
    
                                        <div className="text-center">
                                            <Button className="s-btn" type="submit">
                                                Create Account
                                            </Button>
                                        </div>

                                        <div className="social-login">
                                            <span>OR</span>
                                            <div className="social-btns">
                                                <Button className="facebook-btn"><i className="fa fa-facebook" /> Login with Facebook</Button>
                                                <Button className="twitch-btn"><i className="fa fa-steam" /> Login with Steam</Button>
                                            </div>
                                        </div>

                                    </Form>
                                    <p className="already">Already have an account? <Button className="forget-link" onClick={()=>handleModal("login")}>
                                        Login</Button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;
